import React, { useState } from "react";
import { object, string } from "yup";
import * as yup from "yup";

const useSimulatorsCreateProductForm = () => {
  const validationSchema = object({
    grupoProdutoId: yup.number().notOneOf([0], "O Grupo de Produto é um campo obrigatório").required("O Grupo de Produto é um campo obrigatório"),
    produtoId: yup.number().notOneOf([0], "O Produto é um campo obrigatório").required("O Produto é um campo obrigatório"),
    condicao: yup
      .object()
      .shape({
        manter: yup.boolean(),
        faixa: yup.boolean(),
        especial: yup.boolean(),
      })
      .test("condicao", null, (obj) => {
        const { manter, faixa, especial } = obj;

        if (!manter && !faixa && !especial) {
          return new yup.ValidationError("Selecione uma condição", null, "condicao");
        }
      }),
    grupoProdutoReplicacaoBool: yup.boolean(),
    grupoProdutoReplicacaoId: yup
      .number()
      .test("required", "Campo obrigatório quando o checkbox está marcado", function (value) {
        const { grupoProdutoReplicacaoBool, condicao } = this.parent;
        if ((condicao.faixa || condicao.manter) && grupoProdutoReplicacaoBool && value == "") {
          throw this.createError({
            message: "Campo obrigatório quando o checkbox está marcado",
            path: "grupoProdutoReplicacaoId",
          });
        }
        return true;
      }),
    familiaProdutoReplicacaoBool: yup.boolean(),
    familiaProdutoReplicacaoId: yup
      .number()
      .test("required", "Campo obrigatório quando o checkbox está marcado negociacao", function (value) {
        const { familiaProdutoReplicacaoBool, condicao } = this.parent;
        if ((condicao.faixa || condicao.manter) && familiaProdutoReplicacaoBool && value == "") {
          throw this.createError({
            message: "Campo obrigatório quando o checkbox está marcado negociacao",
            path: "familiaProdutoReplicacaoId",
          });
        }
        return true;
      }),
    produtoReplicacaoBool: yup.boolean(),
    produtoReplicacaoId: yup
      .string()
      .test("required", "Campo obrigatório quando o checkbox está marcado ", function (value) {
        const { produtoReplicacaoBool, condicao } = this.parent;
        if ((condicao.faixa || condicao.manter) && produtoReplicacaoBool && value == "") {
          throw this.createError({
            message: "Campo obrigatório quando o checkbox está marcado select",
            path: "produtoReplicacaoId",
          });
        }
        return true;
      }),
    grupoCentralizadorReplicacaoBool: yup.boolean(),
    grupoCentralizadorReplicacaoId: yup
      .number()
      .test("required", "Campo obrigatório quando o checkbox está marcado ", function (value) {
        const { grupoCentralizadorReplicacaoBool, condicao } = this.parent;
        if ((condicao.faixa || condicao.manter) && grupoCentralizadorReplicacaoBool && value == "") {
          throw this.createError({
            message: "Campo obrigatório quando o checkbox está marcado select",
            path: "grupoCentralizadorReplicacaoId",
          });
        }
        return true;
      }),
    prazoPagamentoId: yup.number()
      // .test("required", "Selecione um prazo", function (value) {
      //   const { condicao } = this.parent;
      //   if (condicao.especial  && value == "") {
      //     throw this.createError({ message: "Campo prazo obrigatório", path: "prazo" });
      //   }
      //   return true;
      // }),
  });

  const [initialValues, setinitialValues] = useState({
    condicao: {
      manter: true,
      faixa: false,
      especial: false,
    },
    grupoProduto: 0,
    produto: 0,
    grupoProdutoReplicacaoBool: false,
    grupoProdutoReplicacaoId: 0,
    familiaProdutoReplicacaoBool: false,
    familiaProdutoReplicacaoId: 0,
    produtoReplicacaoBool: false,
    produtoReplicacaoId: 0,
    grupoCentralizadorReplicacaoBool: false,
    grupoCentralizadorReplicacaoId: 0,
    prazoPagamentoId: 0,
    descontoFob: 0,
    descontoCif: 0,
    precoFinalFob: 0,
    precoFinalCif: 0,
    prazoCif: false ,
    prazoFob: false,
    produtos: [],
    centros: []
  });

  return {
    validationSchema,
    initialValues,
    setinitialValues,
  };
};

export default useSimulatorsCreateProductForm;
